export default function jsonParser(blob) {
	let parsed = JSON.parse(blob);
	if (typeof parsed === 'string') parsed = jsonParser(parsed);
	return parsed;
}